var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableCouchBSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 104 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M83.5 1H103v12.5a2.5 2.5 0 0 1-2.5 2.5H86a2.5 2.5 0 0 1-2.5-2.5V1ZM63 1h19.5v12.5A2.5 2.5 0 0 1 80 16H65.5a2.5 2.5 0 0 1-2.5-2.5V1ZM42.5 1H62v12.5a2.5 2.5 0 0 1-2.5 2.5H45a2.5 2.5 0 0 1-2.5-2.5V1ZM22 1h19.5v12.5A2.5 2.5 0 0 1 39 16H24.5a2.5 2.5 0 0 1-2.5-2.5V1ZM1.5 1H21v12.5a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5V1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M103 11V3.5a2.5 2.5 0 0 0-2.5-2.5H3.644a2.5 2.5 0 0 0-2.5 2.5V11"
})));
SvgNoTableCouchBSelected.viewBox = '0 0 104 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableCouchBSelected);
export default ForwardRef;